import { classInstance } from '@/shared/helpers/helpers';
import { Callbacks, Form } from '@/shared/form/form';

export class PriceRange {
	readonly element: HTMLFormElement;
	protected callbacks?: Callbacks;
	private form: Form;

	private from: HTMLInputElement;
	private to: HTMLInputElement;

	constructor(element: HTMLFormElement, callbacks?: Callbacks) {
		if (!element) return;

		this.element = element;
		this.callbacks = callbacks;

		this.init();
	}

	public init(): void {
		let formInstance = classInstance.get(this.element)?.form;

		if (!formInstance) {
			formInstance = new Form(this.element, this.callbacks);
		} else {
			formInstance.addCallbacks(this.callbacks);
		}

		this.form = formInstance;
		this.from = this.element.querySelector<HTMLInputElement>('.price-range__from .form-input');
		this.to = this.element.querySelector<HTMLInputElement>('.price-range__to .form-input');

		this.from?.addEventListener('blur', this.updateInputState);
		this.to?.addEventListener('blur', this.updateInputState);
	}

	private updateInputState = (): void => {
		const hasFrom = this.from.value.trim().length > 0;
		const hasTo = this.to.value.trim().length > 0;

		const shouldRequire = !(hasFrom || hasTo);

		this.from.required = shouldRequire;
		this.to.required = shouldRequire;

		this.form.formCheck(true);
		this.equalizeInputValues();
	};

	private equalizeInputValues = (): void => {
		const fromRaw = this.normalizeValue(this.from.value.trim());
		const toRaw = this.normalizeValue(this.to.value.trim());

		if (!fromRaw || !toRaw) return;

		const fromValue = Number(fromRaw);
		const toValue = Number(toRaw);

		if (Number.isNaN(fromValue) || Number.isNaN(toValue)) return;

		if (fromValue > toValue) {
			this.to.value = fromValue.toString();
		}
	};

	private normalizeValue = (value: string): number | null => {
		const digits = value.replace(/\D/g, '');
		if (!digits) return null;
		return Number(digits);
	};
}
